var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4334 45.883C15.216 45.8827 14.2602 44.9874 14.2602 43.8474C14.2602 42.7075 15.216 41.8117 16.4334 41.8117C16.9552 41.8117 17.477 41.9746 17.9117 42.3003C18.2597 42.5445 18.6944 42.626 19.0422 42.4633C19.3902 42.3001 19.6509 41.9746 19.738 41.5675C19.8249 40.4273 20.5205 39.4505 21.5641 38.9619V40.509C21.5641 41.0789 22.0859 41.5675 22.6937 41.5675C23.3026 41.5673 23.8242 41.0789 23.8242 40.509L23.8244 38.7177C24.6948 38.9616 25.4765 39.4505 25.9114 40.2648C26.1723 40.6717 26.6939 40.9161 27.1288 40.7532C28.4334 40.4273 29.8245 40.9976 30.3464 42.2188C30.6073 42.7075 31.1291 42.9517 31.6509 42.7889C32.6945 42.463 33.825 43.1961 33.825 44.2546C33.825 45.0687 33.1292 45.8015 32.1727 45.8015H16.4334V45.883ZM10.6939 20.5598C10.6939 15.43 16.868 8.75307 21.825 3.46057C22.0859 3.21614 22.3468 2.97193 22.5206 2.64626C27.3029 7.77581 34.4337 15.0228 34.4337 20.5598C34.4337 26.3409 29.6508 31.145 23.6511 31.6336L23.6514 27.9692L29.6508 24.7123C30.1726 24.4681 30.3464 23.8167 30.0855 23.3283C29.8248 22.8395 29.129 22.677 28.6071 22.9212L23.6514 25.6081V23.8982L27.8247 21.6997C28.3465 21.4555 28.5203 20.8042 28.2593 20.3156C27.9984 19.8269 27.3029 19.6642 26.781 19.9084L23.7383 21.5368V19.9899L26.5201 18.5242C27.0419 18.2798 27.2157 17.6284 26.9548 17.1401C26.6942 16.6512 25.9983 16.4885 25.4765 16.7329L23.8244 17.6285V16.1628L25.6505 15.1855C26.1723 14.9413 26.3471 14.29 26.0852 13.8016C25.8253 13.3127 25.1294 13.1502 24.6079 13.3944L23.9113 13.8016V11.3587C23.9113 10.7886 23.3902 10.3002 22.7808 10.3002C22.1728 10.3002 21.6503 10.7888 21.6503 11.3587V13.8016L20.9554 13.3944C20.4336 13.15 19.738 13.313 19.4771 13.8016C19.2162 14.29 19.39 14.9416 19.9118 15.1858L21.7381 16.1628V17.6285L20.0858 16.7329C19.564 16.4885 18.8682 16.6514 18.6075 17.1401C18.3466 17.6284 18.5204 18.28 19.0422 18.5242L21.825 19.9899V21.5368L18.7813 19.9082C18.2597 19.6642 17.5639 19.8269 17.303 20.3156C17.0421 20.804 17.2161 21.4555 17.7379 21.6997L21.9119 23.8982V25.6081L16.9552 22.9212C16.4334 22.6767 15.7378 22.8397 15.4769 23.3283C15.216 23.8167 15.3897 24.4683 15.9115 24.7125L21.9119 27.9692V31.6334C15.4769 31.145 10.6939 26.3411 10.6939 20.5598ZM44.6943 45.883H35.5642C35.8242 45.3943 35.9111 44.9059 35.9111 44.3358C35.9113 42.3001 34.0857 40.6717 31.8247 40.7532C30.7813 39.2873 29.0421 38.5547 27.2157 38.7177C26.3471 37.6589 25.0418 36.9263 23.6511 36.6819L23.6514 33.5879C30.8682 33.099 36.6076 27.3996 36.6076 20.4785C36.6079 14.6971 30.6073 8.26466 25.3027 2.56477C24.6079 1.83195 23.9113 1.09912 23.3026 0.366297C22.8687 -0.122099 22.0859 -0.122099 21.6503 0.366297C15.9987 6.47333 8.43359 13.9643 8.43359 20.4785C8.43384 27.3994 14.1723 33.0992 21.3901 33.5879L21.3903 36.7632C19.738 37.1703 18.3466 38.3105 17.7379 39.8576C14.8682 38.9616 11.9113 40.9161 11.9113 43.6845C11.9113 44.4171 12.0861 45.1501 12.52 45.7203L9.73813 45.72C9.12943 45.72 8.60762 46.2086 8.60762 46.7787C8.60762 47.3484 9.12943 47.8372 9.73813 47.8372C11.4773 47.8372 41.3027 47.8372 44.5205 47.8372C45.1292 47.8372 45.651 47.3486 45.651 46.7787C45.7379 46.3716 45.2161 45.883 44.6943 45.883Z",
    fill: "url(#paint0_linear_486_1504)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.3908 31.6334C2.7821 31.6334 2.26029 31.145 2.26029 30.5751C2.26029 30.005 2.7821 29.5166 3.3908 29.5166C3.99951 29.5166 4.52133 30.0053 4.52133 30.5751C4.52133 31.145 3.91262 31.6336 3.3908 31.6334ZM6.60833 30.6566C6.60833 28.9465 5.13003 27.5624 3.30368 27.5624C1.47757 27.5621 0 28.9465 0 30.6566C0 32.3662 1.47757 33.7507 3.30368 33.7507C5.13003 33.7507 6.60833 32.285 6.60833 30.6566Z",
    fill: "url(#paint1_linear_486_1504)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.088 30.6567C43.2183 30.6567 42.4356 30.0054 42.4356 29.1096C42.4356 28.2138 43.1315 27.5625 44.088 27.5625C45.0447 27.5622 45.7403 28.2138 45.7403 29.1096C45.7403 30.0052 45.0445 30.6567 44.088 30.6567ZM44.088 25.5269C42.0009 25.5269 40.2617 27.1553 40.2617 29.1096C40.2617 31.0637 42.0009 32.6923 44.088 32.6923C46.1752 32.692 47.9134 31.0639 47.9134 29.1096C47.9134 27.1553 46.175 25.5269 44.088 25.5269Z",
    fill: "url(#paint2_linear_486_1504)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8688 10.2187C47.4931 10.2187 47.9993 10.6928 47.9993 11.2775C47.9993 11.8619 47.4931 12.336 46.8688 12.336C46.2438 12.336 45.7383 11.8621 45.7383 11.2775C45.7383 10.6926 46.2438 10.219 46.8688 10.2187Z",
    fill: "url(#paint3_linear_486_1504)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.0448 4.11171C37.6699 4.11171 38.1751 4.5858 38.1751 5.17044C38.1754 5.75509 37.6699 6.22893 37.0446 6.22893C36.4205 6.22893 35.9141 5.75509 35.9141 5.17044C35.9143 4.5858 36.4205 4.11194 37.0448 4.11171Z",
    fill: "url(#paint4_linear_486_1504)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0876 2.07643C12.7119 2.07643 13.2181 2.55029 13.2181 3.13494C13.2181 3.71958 12.7119 4.19345 12.0876 4.19345C11.4635 4.19322 10.957 3.71958 10.957 3.13494C10.957 2.55029 11.4635 2.07643 12.0876 2.07643Z",
    fill: "url(#paint5_linear_486_1504)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2626 14.29C2.88692 14.29 3.39311 14.7639 3.39311 15.3488C3.39311 15.9332 2.88667 16.4073 2.2626 16.4073C1.63827 16.4071 1.13281 15.9332 1.13281 15.3488C1.13281 14.7639 1.63827 14.29 2.2626 14.29Z",
    fill: "url(#paint6_linear_486_1504)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9586 35.7047C11.583 35.7047 12.0892 36.1788 12.0892 36.7634C12.0892 37.3478 11.583 37.8219 10.9586 37.8219C10.3346 37.8217 9.82812 37.3481 9.82812 36.7634C9.82837 36.1785 10.3346 35.7049 10.9586 35.7047Z",
    fill: "url(#paint7_linear_486_1504)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.1737 35.7047C38.7988 35.7047 39.304 36.1788 39.304 36.7634C39.304 37.3478 38.7985 37.8219 38.1735 37.8219C37.5494 37.8217 37.043 37.3481 37.043 36.7634C37.0432 36.1785 37.5494 35.7049 38.1737 35.7047Z",
    fill: "url(#paint8_linear_486_1504)"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3493 18.3613C40.9736 18.3613 41.4798 18.8352 41.4798 19.4198C41.4798 20.0045 40.9736 20.4786 40.3493 20.4786C39.7252 20.4783 39.2188 20.0045 39.2188 19.4198C39.2188 18.8352 39.725 18.3613 40.3493 18.3613Z",
    fill: "url(#paint9_linear_486_1504)"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.61098 45.883C7.2353 45.8828 7.74149 46.3569 7.74149 46.9415C7.74149 47.5262 7.2353 48 6.61098 48C5.9869 48 5.48047 47.5262 5.48047 46.9415C5.48047 46.3569 5.98666 45.883 6.61098 45.883Z",
    fill: "url(#paint10_linear_486_1504)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_486_1504",
    x1: 27.0471,
    y1: 0,
    x2: 27.0471,
    y2: 47.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_486_1504",
    x1: 3.30417,
    y1: 27.5624,
    x2: 3.30417,
    y2: 33.7507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_486_1504",
    x1: 44.0876,
    y1: 25.5269,
    x2: 44.0876,
    y2: 32.6923,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_486_1504",
    x1: 46.8688,
    y1: 10.2187,
    x2: 46.8688,
    y2: 12.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_486_1504",
    x1: 37.0446,
    y1: 4.11171,
    x2: 37.0446,
    y2: 6.22893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_486_1504",
    x1: 12.0875,
    y1: 2.07643,
    x2: 12.0875,
    y2: 4.19345,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_486_1504",
    x1: 2.26296,
    y1: 14.29,
    x2: 2.26296,
    y2: 16.4073,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_486_1504",
    x1: 10.9586,
    y1: 35.7047,
    x2: 10.9586,
    y2: 37.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_486_1504",
    x1: 38.1735,
    y1: 35.7047,
    x2: 38.1735,
    y2: 37.8219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_486_1504",
    x1: 40.3493,
    y1: 18.3613,
    x2: 40.3493,
    y2: 20.4786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_486_1504",
    x1: 6.61098,
    y1: 45.883,
    x2: 6.61098,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8F5CCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B73CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon10);
export default __webpack_public_path__ + "static/media/icon10.562bc0752ae51494eac3729db0277f4d.svg";
export { ForwardRef as ReactComponent };